/**
 * Dynamic query for marketplace_sellers with filtering support
 */
const sellersQuery = `
query MarketplaceSellers($first: Int!, $skip: Int, $where: Marketplace_sellerWhereInput, $order: [Marketplace_sellerOrder!]) {
  marketplace_sellers(
    first: $first,
    skip: $skip,
    where: $where,
    order: $order
  ) {
    count
    edges {
      node {
        objectId
        name
        phone
        enabled
        public
        b2b
        b2c
        public_prices
        org_pointer {
          objectId
          nome
        }
        createdAt
        updatedAt
      }
    }
  }
}`.replace(/\r?\n|\r/g, "").replace(/\t/g, " ");

export default sellersQuery;
